import React from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "./errorPages/404";

import Reciept from "./Reciept";


const App = ({ match }) => {
  return (
    <div className="gx-main-content-wrapper">
      <Switch>
      <Route path={`${match.url}reciept`} component={Reciept} />
        {/* <Route path={`${match.url}salesAnalysis`} component={SalesAnalysis} />
        <Route path={`${match.url}accountBalance`} component={AccountBalance} />
        <Route path={`${match.url}customerList`} component={CustomerList} />
        <Route path={`${match.url}map`} component={Map} />
        <Route path={`${match.url}request`} component={Request} />
        <Route path={`${match.url}payment`} component={Payment} />
        <Route path={`${match.url}customers`} component={Customers} />
        <Route path={`${match.url}itemsCatalog`} component={ItemsCatalog} />
        <Route path={`${match.url}settings`} component={Settings} /> */}
        {/* <Route path={`${match.url}home`} component={HomePage} />
        <Route path={`${match.url}authenticate`} component={Authenticate} /> */}
        {/* <Route path={`${match.url}requestHistory`} component={RequestHistory} /> */}
        {/* <Route path={`${match.url}addProduct`} component={AddProduct} />
        <Route path={`${match.url}workshop`} component={Workshop} /> */}
        <Route path={`${match.url}*`} component={Reciept} />
        <Route path={`${match.url}*/*/*`} component={Error404} />
      </Switch>
    </div>
  );
};

export default App;
